import { PostIcon } from './PostIcon';

/**
 * author: Google
 * id 9B1DF082-5266-408A-A057-92E9AEB81BFA
 * name post
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post.svg
 * tags
 */
export const BlogIcon = PostIcon;
export default BlogIcon